import React, {memo, useEffect, useState} from 'react';
import ImageComponent from '@/components/UiElements/ImageComponent';
import {FlattedCategory} from '@/types/category';

interface ImageUploadButtonProps {
    graphic: FlattedCategory;
    callBack?: (graphic: FlattedCategory) => void;
}

const ImageUploadButton: React.FC<ImageUploadButtonProps> = (
    {
        graphic,
        callBack,
    }
) => {

    const [callRemove, setCallRemove] = useState(false);

    const classNames = {
        wrapper: `relative block h-[150px] duration-[0.5] !delay-[0.4s] transition-all w-[164px] ${ graphic.type === "deleted" && "w-0 overflow-hidden ml-[-16px]" }`,
        frame:
            'overflow-hidden p-[0px] border-none m-[6px] relative h-[100%] w-[100%] ' +
            `${graphic.type === "upload" && ( 'bg-transparent') }`,
        content:
            'relative flex flex-col w-full h-full rounded-md justify-between items-center transition-all p-[5px] z-20 transition-all duration-[0.4] opacity-100' +
            ` ${ graphic.type === "upload" && ("border border-dashed border-gray-600 !bg-white ") } ` +
            ` ${(graphic.type === "delete" || graphic.type === "deleted")  && ("border border-dashed border-red-300 !bg-red-50") } ` +
            ` ${ graphic.type === "deleted" && ("!opacity-0 scale-[0.5] ") } `,
        imageContainer : 'flex-1 flex justify-center items-center w-full relative opacity-[0.2]'
    };


    useEffect(() => {
        if (graphic.type === 'deleted' && !callRemove) {
            const removeTimer = window.setTimeout(() => {
                setCallRemove(true);
                callBack?.(graphic);
            }, 900);

            return () => window.clearTimeout(removeTimer);
        }

        return undefined;
    }, [graphic.type, graphic.id, callRemove]);

    return (
        <div className={`${classNames.wrapper}  cursor-wait`}>
            <div className={classNames.frame}>

                <div className={classNames.content}>


                    <div
                        className={"bg-transparent h-full w-full absolute top-[0px] z-10 flex items-center justify-center"}
                        style={{mixBlendMode: "multiply"
                        }}
                    >
                        <img
                            src={'/assets/images/Loading.gif'}
                            alt="Loading"
                            className={" w-[50%] h-[50%] object-cover"}

                        />
                    </div>


                    <div
                        className={classNames.imageContainer}
                        style={{ mixBlendMode: "multiply"}}
                    >
                        <ImageComponent src={graphic.img} className="!max-h-[80px]"/>

                    </div>


                </div>
            </div>
        </div>
    );
};

export default memo(ImageUploadButton);
